<p-scrollpanel [style]="{ width: '100%', height: '100%' }" styleClass="w-full">
    <div class="h-full max-h-full flex flex-col gap-2">
        <div class="w-full h-auto bg-white md:rounded-2xl p-4 md:shadow-fm">
            <fm-booking-hub class="h-full" />
        </div>

        <fm-upcoming-session-panel />

        @if (selectedSessions.length > 0) {
            <div class="w-full h-auto bg-white md:rounded-2xl p-4 md:shadow-fm">
                <fm-selected-sessions-list class="h-full" [selectedSessions]="selectedSessions" />
            </div>
        }
    </div>
</p-scrollpanel>
